/* Trophy cabinet filter, and "#buy" links that scroll to the product's buy box. */
document.addEventListener('click', function (event) {
  var kind = event.target.closest('[data-bcb-kind]');
  if (kind) {
    var cab = kind.closest('[data-bcb-cabinet]');
    var want = kind.getAttribute('data-bcb-kind');
    cab.querySelectorAll('[data-bcb-kind]').forEach(function (b) { b.setAttribute('aria-pressed', b === kind ? 'true' : 'false'); });
    cab.querySelectorAll('[data-kind]').forEach(function (cell) { cell.hidden = want !== 'all' && cell.getAttribute('data-kind') !== want; });
    return;
  }
  var buy = event.target.closest('a[href="#buy"]');
  if (buy) {
    var box = document.querySelector('product-info, .product');
    if (box) { event.preventDefault(); box.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }
});
